import { Popover, ActionIcon, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import React from "react";

interface Props {
    text: string;
}

const InfoPopover: React.FC<Props> = ({ text }) => {
    return (
        <Popover width={200} position="bottom" withArrow shadow="md">
            <Popover.Target>
                <ActionIcon variant="transparent">
                    <IconInfoCircle />
                </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown>
                <Text size="xs">{text}</Text>
            </Popover.Dropdown>
        </Popover>
    );
};

export default InfoPopover;
